import type { TemplateGovernanceResult } from '@marketing-hub/shared';
import campStyles from '@/features/campaigns/Campaigns.module.css';

type Props = {
  governance: TemplateGovernanceResult;
};

export function TemplateGovernanceBanner({ governance }: Props) {
  if (governance.blockers.length === 0 && governance.warnings.length === 0) {
    return (
      <div className={campStyles.governanceOkBanner} role="status">
        Review-checklist OK — klaar om op te slaan.
      </div>
    );
  }

  return (
    <div
      className={
        governance.blockers.length ? campStyles.templatePhase1Banner : campStyles.brandDnaBanner
      }
      role="status"
    >
      {governance.blockers.length ? (
        <p className={campStyles.governanceLine}>
          <strong>Blokkeert opslaan:</strong> {governance.blockers.join(' · ')}
        </p>
      ) : null}
      {governance.warnings.length ? (
        <p className={campStyles.governanceLine}>
          <strong>Tip:</strong> {governance.warnings.join(' · ')}
        </p>
      ) : null}
    </div>
  );
}
